import {
  LayoutNodeFilter,
  LayoutNodeFilterType,
} from "@towersystems/roam-common/lib/generated-types";
import {
  fetchCategoriesByIds,
  fetchDepartmentsByIds,
} from "../../../../../../utilities/filter-entities";

export async function fetchAllFilters(filter: LayoutNodeFilter) {
  switch (filter.type) {
    case LayoutNodeFilterType.CATEGORY:
      return fetchCategoriesByIds(filter.values);
    case LayoutNodeFilterType.DEPARTMENT:
      return fetchDepartmentsByIds(filter.values);
  }
}
